// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OyJys","image":"styles_image__2GUnF","wrapper":"styles_wrapper__r6M5g","title":"styles_title__ti5SY","description":"styles_description__r8oQN"};